import Box from '@/components/UI/box/Box';
import Chips from '@/components/UI/chips/Chips';
import Typography from '@/components/UI/typography/Typography';
import { Control, Controller } from 'react-hook-form';
import styles from './FeaturesItemsSection.module.scss';
import { FC } from 'react';
import { MidTermFeatureData } from '../../MidTermFeature';
interface Props {
  item: any;
  control: Control<MidTermFeatureData>;
  fullList?: boolean;
}
const FeaturesItemsSection: FC<Props> = ({
  item,
  control,
  fullList
}) => {
  return <Box className={styles['features-section'] + ' ' + `${fullList ? styles['full-list'] : ''}`} data-sentry-element="Box" data-sentry-component="FeaturesItemsSection" data-sentry-source-file="FeaturesItemsSection.tsx">
      <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="FeaturesItemsSection.tsx">{item.title}</Typography>
      <Box className={styles['features-list']} data-sentry-element="Box" data-sentry-source-file="FeaturesItemsSection.tsx">
        {item.list.map(feature => <Controller key={feature.query} name={feature.query} control={control} render={({
        field: {
          value,
          onChange,
          ...props
        }
      }) => <Chips label={feature.title} onClick={() => onChange(!value)} isSelected={!!value} {...props} />} />)}
      </Box>
    </Box>;
};
export default FeaturesItemsSection;